// @ts-nocheck
import { api } from "./client";
import { isPethernityRequiredError } from "../features/pethernity";

async function signAndPut(path, blob, contentType) {
  const sign = await api.POST(path, {
    body: { contentType },
  });
  if (sign.error || !sign.data) {
    const err = new Error(sign.error?.message ?? "Impossibile generare la URL di upload");
    err.code = sign.error?.code;
    throw err;
  }

  const put = await fetch(sign.data.signedUrl, {
    method: "PUT",
    body: blob,
    headers: { "Content-Type": contentType },
  });
  if (!put.ok) {
    throw new Error(`Upload immagine fallito (${put.status})`);
  }

  return { objectName: sign.data.objectName };
}

export async function uploadPetPhoto(blob) {
  const contentType = blob.type || "image/jpeg";
  try {
    return await signAndPut("/uploads/pet-photo/sign", blob, contentType);
  } catch (err) {
    if (isPethernityRequiredError(err)) throw err;
    throw err;
  }
}

export async function uploadPetMedia(blob, kind) {
  const contentType =
    blob.type || (kind === "video" ? "video/mp4" : "image/jpeg");
  return signAndPut("/uploads/pet-media/sign", blob, contentType);
}
